import jwt_decode from "jwt-decode";
import { getUserDetails } from "../../utils/helper";

const helper = {
    checkPermission(perm) {
        let userInfo = getUserDetails();

        if(!userInfo.permissions)
            return false;
        else
        return userInfo.userrole === perm;
            
          
    }
}

export default helper